import { createSlice } from "@reduxjs/toolkit";
import {
    getGroupLessons,
} from "redux/actions/studentLessons";
import {
    StudentGroupPackLesson,
    StudentGroupSingleLesson,
} from "../models/lessons";

export interface IReservationGroup {
    reservationGroup:  Array<StudentGroupPackLesson | StudentGroupSingleLesson>|null;
    loading: boolean;
}

const initial: IReservationGroup = {
    reservationGroup:null,
    loading:false
};

export const reservationGroupSlice = createSlice({
    name: "reservationGroupSlice",
    initialState: initial,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getGroupLessons.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getGroupLessons.fulfilled, (state, action) => {
            state.loading = false;
            state.reservationGroup = action.payload;
        });
        builder.addCase(getGroupLessons.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export const {} = reservationGroupSlice.actions;

export default reservationGroupSlice.reducer;
